export const prepareEvoCustomAttributes = (customAttributes = {}) => {
    return Object.entries(customAttributes).map(([customAttributeCode, properties]) => {
        var _a;
        return ({
            hint: properties.hint || null,
            type: (_a = properties.type) !== null && _a !== void 0 ? _a : "",
            label: properties.label || null,
            // in EVO types we have behaviour as an array of strings bun in frontend we expect "editable" | "readonly" | "hidden"
            // so we need to align with BE regarding expected values
            behaviour: properties.behaviour || [],
            validation: properties.validation || null,
            display_after: properties.display_after || null,
            is_required: properties.is_required || false,
            is_address_field: properties.is_address_field,
            clearable: properties.clearable,
            code: customAttributeCode,
        });
    });
};
//# sourceMappingURL=prepareEvoCustomAttributes.js.map